;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { StaticImageData } from "next/image";

/**
 * Normalizes image imports (string URLs or StaticImageData) to an object
 * that can be spread into Next.js Image component props.
 *
 * @param image - String URL or StaticImageData object from Next.js import
 * @returns Object with src, width, and height properties for Image component
 *
 * @example
 * ```tsx
 * import logo from "/public/logo.png";
 * <Image {...getImageProps(logo)} alt="Logo" />
 * ```
 */
export function getImageProps(image: string | StaticImageData): {
	src: string;
	width?: number;
	height?: number;
} {
	if (typeof image === "string") {
		return { src: image };
	}

	return {
		height: image.height,
		src: image.src,
		width: image.width,
	};
}
